import React from 'react';

const TitleDescBoxes = ({ imgWebp, imgJpg, imgPng, videoSrc, imgAlt, title, subtitle, desc }) => {
  return (
    <section className='title-desc-boxes'>
        <div className='container'>
            <div className='container-box text-center '>
                <h3 className='title'>Discover the Benefits of Clean Water</h3>
                <p className='desc mobile-text-left'>In partnership with Water Analytics, a leader in water filtration technology, we bring you state-of-the-art systems designed to deliver clean, safe water throughout your home. Water Analytics is renowned for its rigorous approach to quality, ensuring each system is crafted to meet the highest standards of water purity and performance.</p>
            </div>
            <div className='box-holder'>
                <div className='box'>
                    <picture>
                        <source type="image/png" srcSet="/img/trash-icon.png" />
                        <img src="/img/trash-icon.png" alt="Responsive" />
                    </picture>
                    <h4>Advanced Filtration
                    Technology for Your Home</h4>
                    <p className='desc'>Utilising cutting-edge technology, our system removes impurities effectively.</p>
                </div>
                <div className='box'>
                    <picture>
                        <source type="image/png" srcSet="/img/leaf-round-icon.png" />
                        <img src="/img/leaf-round-icon.png" alt="Responsive" />
                    </picture>
                    <h4>Advanced Filtration
                    Technology for Your Home</h4>
                    <p className='desc'>Utilising cutting-edge technology, our system removes impurities effectively.</p>
                </div>
                <div className='box'>
                    <picture>
                        <source type="image/png" srcSet="/img/money-icon.png" />
                        <img src="/img/money-icon.png" alt="Responsive" />
                    </picture>
                    <h4>Advanced Filtration
                    Technology for Your Home</h4>
                    <p className='desc'>Utilising cutting-edge technology, our system removes impurities effectively.</p>
                </div>
                <div className='box'>
                    <picture>
                        <source type="image/png" srcSet="/img/building-icon.png" />
                        <img src="/img/building-icon.png" alt="Responsive" />
                    </picture>
                    <h4>Advanced Filtration
                    Technology for Your Home</h4>
                    <p className='desc'>Utilising cutting-edge technology, our system removes impurities effectively.</p>
                </div>
                <div className='box'>
                    <picture>
                        <source type="image/png" srcSet="/img/key-icon.png" />
                        <img src="/img/key-icon.png" alt="Responsive" />
                    </picture>
                    <h4>Advanced Filtration
                    Technology for Your Home</h4>
                    <p className='desc'>Utilising cutting-edge technology, our system removes impurities effectively.</p>
                </div>
                <div className='box'>
                    <picture>
                        <source type="image/png" srcSet="/img/house-icon.png" />
                        <img src="/img/house-icon.png" alt="Responsive" />
                    </picture>
                    <h4>Advanced Filtration
                    Technology for Your Home</h4>
                    <p className='desc'>Utilising cutting-edge technology, our system removes impurities effectively.</p>
                </div>
            </div>
        </div>
    </section>
  )
}

export default TitleDescBoxes;